
export default function ErrorMessage({message}){
    return (
        <div className="row justify-content-center align-items-center mt-4">
            <div className="alert alert-danger col-5 text-center">
                An Error has occured. Please wait a few minutes before trying again.
            </div>
        </div>
    );
}